import {DetectionDetailsModalProps} from "../constants/DetectionInterfaces";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseRoundedIcon from "@mui/icons-material/Close";
import * as React from "react";
import {useTranslation} from "react-i18next";
import {Theme} from "@mui/material/styles";
import {
    UserLegalEntitiesOrDealersInputGroup
} from "../../../component/UserLegalEntitiesOrDealersInputGroup/UserLegalEntitiesOrDealersInputGroup";
import dayjs from "dayjs";

const DetectionDetailsModal = ({open, detection, handleClose}: DetectionDetailsModalProps) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'detection'});
    const theme: Theme = useTheme();

    return (
        <>
            {detection &&
                <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={open}
                        onClose={() => {
                            return;
                        }}>
                    <DialogTitle>
                        <Typography fontWeight={"bold"} color={"primary"}>
                            {t('details.title')}
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => {
                                handleClose();
                            }}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                            }}
                        >
                            <CloseRoundedIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container rowSpacing={3} columnSpacing={3}>
                            <UserLegalEntitiesOrDealersInputGroup
                                tenantId={detection.tenantId}
                                dealerId={detection.dealerId}/>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.paymentStatus')}
                                    value={detection.paymentStatus ? t('paymentStatuses.' + detection.paymentStatus) : ""}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.subscriptionId')}
                                    value={detection.subscriptionId}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.kmAccrued')}
                                    value={detection.kmAccrued}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.kmRemaining')}
                                    value={detection.kmRemaining}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.kmDetected')}
                                    value={detection.kmDetected}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{readOnly: true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.detectionDate')}
                                    value={detection.detectionDate ? dayjs(detection.detectionDate).format("ll") : '--'}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.creditNote')}
                                    value={detection.creditNoteId? detection.creditNoteId : '--'}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('columns.creditNoteDate')}
                                    value={detection.creditNoteDate ? dayjs(detection.creditNoteDate).format("ll") : '--'}
                                    margin="dense"
                                    variant="standard"
                                    inputProps={{
                                        readOnly: true
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                        <Button color={"accent"}
                                onClick={() => handleClose()}>{t('details.close')}</Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    );
}
export default DetectionDetailsModal;